import type { SceneEntity } from '@seddi/scene';
import type { LoadingManager } from '@seddi/three';
import log from 'loglevel';

import { ResourceManager } from './resourceManager';
import { load } from './garmentGeometryLoader';
import type { GarmentGeometryGfx } from './garmentGeometryTypes';
import type { ResourceContextConfig } from './resourcesContextConfig';

export type GarmentGeometryDesc = { children: SceneEntity[]; id: string; url: string };

/**
 * Garment geometry resources context.
 */
export class GarmentGeometriesContext extends ResourceManager<GarmentGeometryGfx> {
  readonly config: ResourceContextConfig;
  readonly manager: LoadingManager;

  constructor(manager: LoadingManager, config: ResourceContextConfig) {
    super();
    this.config = config;
    this.manager = manager;
  }

  /**
   * Load garment geometry.
   * @param desc - Descriptor.
   */
  async loadAsync(desc: GarmentGeometryDesc): Promise<GarmentGeometryGfx | undefined> {
    if (this.find(desc.id)) {
      log.warn(`GarmentGeometriesContext.loadAsync: ${desc.id} is not new.`);
      return undefined;
    }

    const item = this.create(desc.id);
    item.status = 'loading';

    const value = await load(desc.url, desc.children, this.manager, this.config);
    item.status = 'ready';
    item.value = value;

    if (this.onLoad) {
      this.onLoad(desc.id, 'GarmentGeometry');
    }

    return value;
  }
}
